// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1jokQ","form":"styles_form__fNrYI"};